import { Checkbox, ColorPicker } from 'antd';
import React, { memo, useEffect, useState } from 'react';

function ColorSelector({ title, value, shouldVisible, onChange }) {
  const [canSelect, setCanSelect] = useState(shouldVisible);

  useEffect(() => {
    if (shouldVisible) setCanSelect(true);
  }, [shouldVisible]);

  return (
    <div className="timer-config">
      <Checkbox
        style={{ minWidth: 160, paddingBlock: 5 }}
        checked={canSelect}
        onChange={(event) => {
          const checked = event.target.checked;

          setCanSelect(checked);

          onChange(checked ? '#722ed1' : null);
        }}
      >
        <span className="timer-title">{title}</span>
      </Checkbox>
      {canSelect && (
        <ColorPicker
          disabledAlpha
          disabledFormat
          format="hex"
          showText
          arrow={false}
          value={value}
          onChange={(value) => onChange(value.toHexString())}
        />
      )}
    </div>
  );
}

const Memoized = memo(ColorSelector);

export { Memoized as ColorSelector };
